
import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormDescription, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ContractFormValues } from "../ContractFormSchema";
import { useTranslation } from "react-i18next";

interface ContractRemindersSectionProps {
  form: UseFormReturn<ContractFormValues>;
}

export function ContractRemindersSection({ form }: ContractRemindersSectionProps) {
  const { t } = useTranslation();
  
  return (
    <div className="grid gap-4 md:grid-cols-2">
      <FormField
        control={form.control}
        name="reminderPeriod"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('reminderPeriod', 'Reminder Period')}</FormLabel>
            <Select
              onValueChange={field.onChange}
              value={field.value}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder={t('selectReminderPeriod', 'Select reminder period')} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="1 week">{t('oneWeekBefore', '1 week before')}</SelectItem>
                <SelectItem value="2 weeks">{t('twoWeeksBefore', '2 weeks before')}</SelectItem>
                <SelectItem value="1 month">{t('oneMonthBefore', '1 month before')}</SelectItem>
                <SelectItem value="2 months">{t('twoMonthsBefore', '2 months before')}</SelectItem>
                <SelectItem value="3 months">{t('threeMonthsBefore', '3 months before')}</SelectItem>
                <SelectItem value="6 months">{t('sixMonthsBefore', '6 months before')}</SelectItem>
              </SelectContent>
            </Select>
            <FormDescription>
              {t('reminderPeriodDescription', 'How long before expiry to start reminders')}
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="reminderFrequency"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('reminderFrequency', 'Reminder Frequency')}</FormLabel>
            <Select
              onValueChange={field.onChange}
              value={field.value}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder={t('selectReminderFrequency', 'Select reminder frequency')} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="Once">{t('onceOnly', 'Once only')}</SelectItem>
                <SelectItem value="Weekly">{t('weekly', 'Weekly')}</SelectItem>
                <SelectItem value="Monthly">{t('monthly', 'Monthly')}</SelectItem>
              </SelectContent>
            </Select>
            <FormDescription>
              {t('reminderFrequencyDescription', 'How often to send reminders')}
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
